import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.notice.admin.detail');
import { OnInit, Input, DoCheck, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";
// import ClassicEditor from "src/libs/ckeditor/ckeditor";
import ClassicEditor from "src/libs/portal/season/ckeditor/ckeditor";

@Component({
    selector: 'wiz-portal-notice-admin-detail',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.notice.admin.detail/view.scss */
/* src/app/portal.notice.admin.detail/view.scss: no such file or directory */`],
})
export class PortalNoticeAdminDetailComponent implements OnInit, DoCheck {
    constructor(@Inject( Service)         public service: Service,@Inject( Router    )         private router: Router    ) { }

    @Input() category: any;
    @Input() docID: any;

    @ViewChild('editor')
    public editorElement: ElementRef;

    public info: any;
    public prev: any;
    public next: any;
    private lastUrl: string = "";
    public files: any;

    public fd = new FormData();
    private allowedExt = [
        'pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'txt',
        'png', 'jpg', 'jpeg', 'gif', 'webp'
    ];
    private maxSize = 10 * 1024 * 1024; // 10MB

    public async ngDoCheck() {
        if (this.router.url !== this.lastUrl && this.docID != 'new') {
            this.lastUrl = this.router.url;
            this.docID = WizRoute.segment.id;
            this.load();
        }
    }

    public async ngOnInit() {
        await this.service.init();
        await this.load();
        await this.buildEditor();
        await this.service.render();
    }

    public async load() {
        if (this.docID != 'new') {
            const { code, data } = await wiz.call("load", { docID: this.docID, category: this.category });
            if (code != 200) return await this.service.alert.error("Error!");

            this.info = data.info;
            this.info.attachments = JSON.parse(this.info.attachments.replace(/'/g, '"'));
            this.prev = data.prev;
            this.next = data.next;
        } else {
            this.info = {
                category: "alert",
                status: "draft",
                title: "",
                content: "",
                attachments: []
            }
            // this.info = {};
        }

        await this.service.render();
    }

    public async submit() {
        if (!this.info.title || this.info.title == "") return await this.service.alert.warning("제목을 작성해주세요.");
        this.info.content = this.editor.data.get();
        if (!this.info.content || this.info.content == "") return await this.service.alert.warning("내용을 작성해주세요.");

        let url = wiz.url('submit')
        this.fd.append('info', JSON.stringify(this.info))
        const { code, data } = await this.service.file.upload(url, this.fd);

        if (code != 200) return await this.service.alert.error("Error!");
        await this.service.alert.success("새로운 공지가 등록되었습니다.");
        await this.router.navigate([`/admin/notices/${this.info.category}`]);
    }

    public async upload() {
        let files = await this.service.file.select({ accept: '.pdf,.hwp,.hwpx,.doc,.docx,.xls,.xlsx,.ppt,.pptx', multiple: true });

        this.loaded = false;
        await this.service.render();

        let fd = new FormData();
        let fileSizes = [];

        for (let i = 0; i < files.length; i++) {
            let file = files[i]
            if (!file.filepath) file.filepath = file.name;
            fd.append('file[]', file);
            fileSizes.push(file.size)
        }
        fd.append("insID", this.insID);
        fd.append("filesize", JSON.stringify(fileSizes))

        let url = wiz.url('upload');
        const { code } = await this.service.file.upload(url, fd)
        if (code != 200) return await this.service.alert.error("Error!");
        else this.loaded = true;
        await this.service.render();

        await this.load();
    }

    public async buildEditor() {
        // let editor = this.editor = await ClassicEditor.create(this.editorElement.nativeElement, {
        let editor = this.editor = await ClassicEditor.create(document.querySelector("textarea#editor"), {
            toolbar: {
                items: [
                    'undo', 'redo',
                    '|', 'heading',
                    '|', 'alignment:left', 'alignment:center', 'alignment:right', 'alignment:justify',
                    // '|', 'alignment',
                    '|', 'bold', 'italic', 'strikethrough', 'underline',
                    // '|', 'bulletedList', 'numberedList', 'outdent', 'indent',
                    '|', 'outdent', 'indent',
                    '|', 'link', 'uploadImage', 'insertTable', 'blockQuote', 'codeBlock', 'horizontalLine'
                ],
                // items: 'heading | bold italic strikethrough underline | fontColor highlight fontBackgroundColor | bulletedList numberedList todoList | outdent indent | insertTable | link blockQuote code codeBlock'.split(' '),
                shouldNotGroupWhenFull: true
            },
            link: {
                addTargetToExternalLinks: true,
                defaultProtocol: 'https://',
            },
            removePlugins: ["MediaEmbedToolbar", "Markdown"],
            table: ClassicEditor.defaultConfig.table,
            simpleUpload: {
                uploadUrl: '/file/upload'
            }
        });

        this.editor.editing.view.change(writer => {
            writer.setStyle(
                "min-height",
                "300px",   // 원하는 높이
                editor.editing.view.document.getRoot()
            );
        });

        this.editor.data.set(this.info.content);
    }

    public async statusChange(value: any) {
        this.info.status = value;
        await this.service.render();
    }

    public async categoryChange(value: any) {
        this.info.category = value;
        await this.service.render();
    }

    public async fileUpload(e) {
        for (let i = 0; i < e.target.files.length; i++) {
            let file = e.target.files[i]
            this.filename = file.name;
            if (!file.filepath) file.filepath = file.name;
            this.fd.append('file[]', file);
            let fileInfo = { name: file.name, size: file.size }
            this.info.attachments.push(fileInfo);
        }
        console.log("attchment : ", this.info.attachments);
        await this.service.render();
    }

    // (선택) 드래그&드롭 지원을 추가하고 싶으면 템플릿에 (drop)/(dragover) 바인딩 후 이 메서드 사용
    public handleDropFiles(files: FileList | File[]) {
        this.addFiles(files);
    }

    public removeAttachment(index: number) {
        this.info.attachments = this.info.attachments.filter((_, i) => i !== index);
    }

    public formatFileSize(bytes: number) {
        if (!Number.isFinite(bytes)) return '-';
        const units = ['B', 'KB', 'MB', 'GB'];
        let i = 0, size = bytes;
        while (size >= 1024 && i < units.length - 1) { size /= 1024; i++; }
        return `${Math.round(size * 100) / 100} ${units[i]}`;
    }

    public getFileIcon(filename: string) {
        const ext = this.getExt(filename);
        switch (ext) {
            case 'pdf': return '📕';
            case 'doc':
            case 'docx': return '📝';
            case 'xls':
            case 'xlsx': return '📊';
            case 'ppt':
            case 'pptx': return '📈';
            case 'txt': return '📄';
            case 'png':
            case 'jpg':
            case 'jpeg':
            case 'gif':
            case 'webp': return '🖼️';
            default: return '📦';
        }
    }

    private getExt(name: string): string | null {
        const i = name.lastIndexOf('.');
        return i >= 0 ? name.slice(i + 1).toLowerCase() : null;
    }
}

export default PortalNoticeAdminDetailComponent;